import React, { Fragment } from 'react';
import SectionRoutine from 'components/templates/SectionRoutine/SectionRoutine';
import { appStructure } from 'helpers/navigationHelper';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import SectionTips from 'components/templates/SectionTips/SectionTips';

import { Loadable } from 'dataLayer/recoil/Loadable';
import SwipeableView from 'components/molecules/SwipeableView/SwipeableView';
import {
  exerciseRoutineMorningSelector,
  exerciseRoutineOfficeSelector,
  exerciseRoutineWorkoutSelector,
} from 'dataLayer/recoil/pages/stayActive/selectors';
import { stayActiveTipsAtom } from 'dataLayer/recoil/pages/sections/atoms';
import RenderSectionProfile from 'pages/RenderSectionProfile/RenderSectionProfile';
import { stayActiveTraitsSelector } from 'dataLayer/recoil/pages/sections/selectors';

const StayActiveTips = (props) => {
  const { data } = props;

  return (
    <Fragment>
      <SwipeableView id="swipeable-tips">
        {data.map((item) => (
          <SectionTips {...item} />
        ))}
      </SwipeableView>
    </Fragment>
  );
};

const ExerciseRoutine = (props) => {
  const { data } = props;

  return (
    <Fragment>
      <SwipeableView id="swipeable-morning">
        {data.map((exerciseRoutineData) => {
          return <SectionRoutine {...exerciseRoutineData} />;
        })}
      </SwipeableView>
    </Fragment>
  );
};

const StayActiveProfile = (props) => {
  const reportData = {
    report_code: 'fitness',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

export default function StayActiveSection(props) {
  let { path } = useRouteMatch();

  const subsections = appStructure.sections[2].subsections;

  return (
    <Fragment>
      <Switch>
        <Route exact path={path}>
          <Redirect
            to={{
              pathname: subsections[0].route,
            }}
          />
        </Route>
        <Route
          path={subsections[0].route}
          render={() => (
            <Loadable
              value={exerciseRoutineMorningSelector}
              component={ExerciseRoutine}
            />
          )}
        />
        <Route
          path={subsections[1].route}
          render={() => (
            <Loadable
              value={exerciseRoutineOfficeSelector}
              component={ExerciseRoutine}
            />
          )}
        />
        <Route
          path={subsections[2].route}
          render={() => (
            <Loadable
              value={exerciseRoutineWorkoutSelector}
              component={ExerciseRoutine}
            />
          )}
        />
        <Route
          path={subsections[3].route}
          render={() => (
            <Loadable value={stayActiveTipsAtom} component={StayActiveTips} />
          )}
        />
        <Route
          path={subsections[4].route}
          render={() => (
            <Loadable
              value={stayActiveTraitsSelector}
              component={StayActiveProfile}
            />
          )}
        />
      </Switch>
    </Fragment>
  );
}
